import { PropsWithChildren } from 'react';
import classes from './Alert.module.css';

type Props = PropsWithChildren<{ message: string; type: 'danger' | 'success' }>;

const Alert: React.FC<Props> = ({ message, type }: Props): React.ReactElement => {
  return (
    <div className={`alert alert-${type} ${classes.bump}`} role="alert">
      {message}
    </div>
  );
};

export default Alert;
